
  <div class="row">
    <div class="col-lg-12 mb-1" style="position: relative;">
      <!-- Centering wrapper with responsive margins -->
      <div class="d-flex justify-content-center mt-3 px-3">
        <div class="w-100 lg-large-margins">
          <!-- Floating AI Chat Card -->
          <h1 class="text-center mb-3 responsive-heading" i18n>The best way to get things done</h1>
          <div class="m-auto mb-3" style="top: 20%; margin-top: 2rem;">
            <div class="card border-0">
              <div class="card-body p-4 pb-0">
                <div class="input-group mt-0 mb-3 shadow">
                  <span class="input-group-text" style="border: none !important; background-color: #eee !important;">
                    <img alt="Sparkles" i18n-alt src="assets/images/sparkles.webp" style="width: 1.2rem; height: 1.2rem; position: relative; top: -2px;">
                    </span>
                  <div #promptInput enterkeyhint="send"
                    (keydown.enter)="agentSend(); $event.preventDefault();"
                    [attr.placeholder]="firstPromptSent ? '': placeholderText" contenteditable="true"
                    class="textarea form-control" style="border: none !important; outline: none !important; box-shadow: none !important;">
                  </div>
                  <button *ngIf="!isMobile" (click)="agentSend()" class="btn btn-primary">
                    <span class="d-none d-sm-inline me-1" i18n>Send</span>
                    <fa-icon [icon]="fa.faPaperPlane" style="color: #fff;" class="plane-sm-hack"></fa-icon>
                  </button>
                </div>

                <div class="m-2">
                  <div class="row">
                    <div class="p-0" style="width: 3rem; height: 3.5rem;">
                      <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-round.webp"
                        style="border-radius: 50%; width: 3rem;" class="pr-5 shadow mx-1">
                    </div>
                    <div class="col align-middle px-3">
                      <div class="text-muted" i18n>Sales Agent</div>
                      <div *ngIf="!firstPromptSent" class="d-inline-block">
                        <p>
                          {{ prompt | translateField: 'greeting' }}
                          <span *ngIf="!prompt" [innerHTML]="animatedDots"></span>&nbsp;
                        </p>
                      </div>
                      <div *ngIf="firstPromptSent && agentResponse == ''" class="d-inline-block">
                        <p>
                          <span [innerHTML]="animatedDots"></span>&nbsp;
                        </p>
                      </div>
                      <div *ngIf="firstPromptSent && agentResponse != ''" class="d-inline-block" [innerHTML]="agentResponse"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="assignments.length > 0" class="row">
            <ng-container *ngFor="let assignment of assignments | localeSort: 'name'; let i = index">
              <div class="mb-3 px-3" [ngClass]="{
                  'col-12': assignments.length === 1,
                  'col-12 col-xl-6': assignments.length > 1
                }">
                <div (click)="selectAssignment(assignment)" class="card card m-0 h-100 w-100 cursor-pointer"
                  style="overflow: hidden; background-image: url('{{assignment.picture}}'); background-size: cover; background-position: 0 25%; height: 11rem;">
                  <div class="card-header" style="height: 11rem; border: none;"></div>
                  <div class="card-body p-3 d-flex justify-content-between"
                    style="background: rgba(255,255,255,0.85); margin-top: auto;">
                    <div class="d-flex flex-column">
                      <h4 class="card-title">{{ assignment | translateField: 'name' }}</h4>
                      <p class="card-text">{{ assignment | translateField: 'description_short' }}</p>
                    </div>
                    <div class="d-flex align-items-center ms-3">
                      <fa-icon [icon]="fa.faChevronCircleRight" style="font-size: 1.7rem;"></fa-icon>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <div *ngIf="assignments.length > 0 && assignments.length != assignmentsAll.length" class="mb-3 px-3 col-12">
              <button (click)="showAllAssignments()" class="btn btn-primary w-100 mb-0" i18n>Show all</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <button *ngIf="this.shiftForm.controls.products.value && this.shiftForm.controls.products.value.length > 0 && this.shiftForm.controls.assignment_id.value" 
    (click)="navigateToOrder()"
    class="btn btn-primary rounded-circle position-fixed"
    style="top: 80px; right: 20px; width: 60px; height: 60px; z-index: 1000;">
    <fa-icon [icon]="fa.faShoppingCart" style="font-size: 1.5rem; color:#fff;"></fa-icon>
    <span class="position-absolute bg-secondary text-white rounded-pill px-2" style="top: 8px; right: 8px;">{{
      this.shiftForm.controls.products.value?.length }}</span>
  </button>